import React, { PureComponent } from 'react';
import styled from 'styled-components';

import ConductResearchData from "../../../data/onboarding/conduct-research.json";
import ConductResearchImage from '../../../containers/assets/onboarding-conduct-research.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;
`;

const FormulaBlock = styled.div`
  background: #6FD1D9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  margin-top: 12px;
`;

const FormulaLeftPart = styled.div`
  background: #2A4169;
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  text-align: center;
  margin-right: 12px;
  min-height: 120px;
  display: flex;
  align-items: center;
`;

const EqualitySign = styled.div`
  width: 16px;
  height: 7px;
  position: relative;

  &:before, &:after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 1.5px;
    background: rgba(0, 27, 59, 0.94);
    border-radius: 100px;
  }

  &:before {
    top: 0;
  }

  &:after {
    bottom: 0;
  }
`;

const FormulaRightPart = styled.div`
  display: flex;
  flex-direction: column;
  width: 212px;
  margin-left: 12px;
  text-align: center;
  color: rgba(0, 27, 59, 0.94);
`;

const FormulaDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(0, 27, 59, 0.94);
  margin: 12px 0;
`;

const Image = styled.div`
  margin-left: 5px;
  position: relative;
  padding: 0 12px;

  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 8px;
    height: 43px;
    left: 0;
    right: 0;
    border-radius: 4px;
    border: 2px solid #2A4169;
  }
`;

class ConductResearch extends PureComponent {

  render() {
    const { roundInUrl } = this.props;

    return (
      <Wrapper>
        <Container>
          <Text1>What to expect</Text1>
          <Text2>Conduct Research | Prior Round Financial Statements</Text2>
          <Text3>
            <p>{ConductResearchData.rounds[roundInUrl - 1].text3}</p>
          </Text3>
          <FormulaBlock>
            <FormulaLeftPart>
              <p>ROI Metrics</p>
            </FormulaLeftPart>
            <EqualitySign></EqualitySign>
            <FormulaRightPart>
              <p>Income Statements</p>
              <FormulaDivider></FormulaDivider>
              <p>Balance Sheet</p>
            </FormulaRightPart>
            <Image>
              <img src={ConductResearchImage} alt=""></img>
            </Image>
          </FormulaBlock>
        </Container>
      </Wrapper>
    );
  }

}

export default ConductResearch;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/ConductResearch.js